export default __webpack_public_path__ + "static/media/minimal.2b31c843.png";